/* -----------------Types--------------- */
import { titleCase } from "@memorang/helpers/common";
import Box from "@memorang/ui/components/Box";
import TooltipWrapper from "@memorang/ui/components/TooltipWrapper";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";

/* -----------------Child components--------------- */
import { Chip } from "react-native-paper";
import type { MixedItemTag } from "types/tag";

type Props = {
	tags: MixedItemTag[];
};
export const TagsList = ({ tags }: Props) => {
	return (
		<Box>
			<CustomListSubheaderContainer
				enableGutters={false}
				textVariant="titleMedium"
			>
				Tags
			</CustomListSubheaderContainer>
			<Box gap={8} flexDirection="row" flexWrap="wrap">
				{tags.map(({ label, type }, index) => {
					const title = type ? `${titleCase(type)}: ${label}` : label;
					if (title && title.length > 35) {
						return (
							<TooltipWrapper key={title} title={title}>
								<Chip
									style={{
										maxWidth: 300,
									}}
									testID={`tag-${index + 1}`}
								>
									{title}
								</Chip>
							</TooltipWrapper>
						);
					}
					return (
						<Chip
							key={title}
							style={{
								maxWidth: 300,
							}}
						>
							{title}
						</Chip>
					);
				})}
			</Box>
		</Box>
	);
};
